import React, { Component } from "react";
import IconButton from "@material-ui/core/IconButton";
import PhotoCamera from "@material-ui/icons/PhotoCamera";

export class ProfilePic extends Component {
  render() {
    const { data, edit, imageHandler } = this.props;
    return (
      <div style={{ position: "relative" }}>
        <div className="avatar z-depth-1-half">
          <img
            src={data.photoURL}
            alt={data.firstName + " " + data.lastName}
            className="img-fluid"
            id="profile_img"
          />
        </div>
        <div style={{ position: "absolute", top: 30, left: 115 }}>
          <input
            accept="image/*"
            className="d-none"
            id="icon-button-file"
            type="file"
            disabled={!edit}
            onChange={(e) => imageHandler(e)}
          />
          <label htmlFor="icon-button-file">
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              disabled={!edit}
            >
              <PhotoCamera />
            </IconButton>
          </label>
        </div>
      </div>
    );
  }
}

export default ProfilePic;
